import React from 'react';
import { Box } from '@mui/material';
import BreadcrumbsContainer from '../../common/breadcurmbs/BreadcrumbsContainer';
import WorkflowList from '../../../components/manufacturingmng/workflow/WorkflowList';

const WorkflowContainer = ({ pageUrl }) => {
  return (
    <>
      <BreadcrumbsContainer title="생산/워크플로우 관리" icon="settings" />

      <Box sx={{ p: 2 }}>
        <WorkflowList />
      </Box>
    </>
  );
};

export default WorkflowContainer;
